import { render, staticRenderFns } from "./Pnr.vue?vue&type=template&id=171aae3c&"
import script from "./Pnr.vue?vue&type=script&lang=js&"
export * from "./Pnr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports